import React from 'react';
import { ChatTrigger } from '@fiverr-private/support_chat_trigger';
import './style.scss';

const SupportChat = ({ reason }) =>
    (<div className="t-a-center p-b-40">
        <ChatTrigger chatId="business"
            department="Fiverr Business"
            tags={['listing-chat', reason]}/>
    </div>);

export default SupportChat;
